module.exports = __webpack_public_path__ + "static/media/winelivery-logo.5342a49d.svg";